import clsx from 'clsx';
import { InHandDateDisplay } from 'src/components/common/InHandDateDisplay';

import { inHandOverriddenCellBackground } from './InHandCell.css';

export type InHandCellProps = {
  date: Date | null;
  needsToFulfill?: boolean;
  handleFulfillmentState?: boolean;
  inHandDateOverriddenByMsbd?: boolean;
};

export const InHandCell = ({
  date,
  needsToFulfill,
  handleFulfillmentState,
  inHandDateOverriddenByMsbd,
}: InHandCellProps) => {
  return (
    <InHandDateDisplay
      date={date}
      needsToFulfill={needsToFulfill}
      handleFulfillmentState={handleFulfillmentState}
      inHandDateOverriddenByMsbd={inHandDateOverriddenByMsbd}
      showAbsoluteDate={true}
      className={clsx({
        [inHandOverriddenCellBackground]: inHandDateOverriddenByMsbd,
      })}
    />
  );
};
